function typeOf(type: 'function' | 'boolean' | 'number' | 'string' | 'null' | 'undefined' | 'object') {
  return function (value: unknown): value is typeof type {
    return typeof value === type;
  };
}

export const isFunction = typeOf('function');
export const isNumber = typeOf('number');
export const isString = typeOf('string');
export const isObject = (value: unknown) => value !== null && typeOf('object')(value);

export function isDefined<T>(arg: T | undefined): arg is T {
  return typeof arg !== 'undefined';
}
